import React from "react"
import { Control, FieldPath, FieldValues } from "react-hook-form"
import { FormControl, FormField, FormItem, FormLabel, FormErrorMessage } from "@/components/ui/form"
import { Checkbox } from "@/components/ui/checkbox"

interface FormCheckboxFieldProps<TFieldValues extends FieldValues> {
  control: Control<TFieldValues>
  name: FieldPath<TFieldValues>
  label: string
  disabled?: boolean
  className?: string
}

export function FormCheckboxField<TFieldValues extends FieldValues>({
  control,
  name,
  label,
  disabled,
  className,
}: FormCheckboxFieldProps<TFieldValues>) {
  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => (
        <FormItem className={className}>
          <div className="flex h-12 flex-row items-center space-x-3 space-y-0 rounded-lg border border-input bg-muted/10 p-4 transition-colors hover:bg-muted/20">
            <FormControl>
              <Checkbox
                checked={field.value}
                onCheckedChange={field.onChange}
                disabled={disabled}
                className="data-[state=checked]:border-primary data-[state=checked]:bg-primary"
              />
            </FormControl>
            <div className="leading-none">
              <FormLabel className="mb-0 cursor-pointer">{label}</FormLabel>
            </div>
          </div>
          <FormErrorMessage />
        </FormItem>
      )}
    />
  )
}

